import { Extension, Mark, mergeAttributes } from "@tiptap/react";
import { Plugin } from "@tiptap/pm/state";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import Link from "@tiptap/extension-link";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableHeader from "@tiptap/extension-table-header";
import TableCell from "@tiptap/extension-table-cell";
import Image from "@tiptap/extension-image";
import Placeholder from "@tiptap/extension-placeholder";

export const FontSize = Extension.create({
  name: "fontSize",
  addGlobalAttributes() {
    return [{
      types: ["textStyle"],
      attributes: {
        fontSize: {
          default: null,
          parseHTML: (el) => el.style.fontSize || null,
          renderHTML: (a) => (a.fontSize ? { style: `font-size: ${a.fontSize}` } : {}),
        },
      },
    }];
  },
  addCommands() {
    return {
      setFontSize: (size) => ({ chain }) => chain().setMark("textStyle", { fontSize: size }).run(),
      unsetFontSize: () => ({ chain }) => chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run(),
    };
  },
});

export const CommentMark = Mark.create({
  name: "comment",
  inclusive: false,
  excludes: "",
  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: (el) => el.getAttribute("data-comment-id"),
        renderHTML: (a) => ({ "data-comment-id": a.commentId }),
      },
    };
  },
  parseHTML() { return [{ tag: "span[data-comment-id]" }]; },
  renderHTML({ HTMLAttributes }) { return ["span", mergeAttributes(HTMLAttributes, { class: "doc-comment" }), 0]; },
});

// Comment-only mode: the text can't change; only transactions tagged allowComment may alter the doc.
export const CommentOnly = Extension.create({
  name: "commentOnly",
  addProseMirrorPlugins() {
    return [new Plugin({ filterTransaction: (tr) => !tr.docChanged || !!tr.getMeta("allowComment") })];
  },
});

export const buildExtensions = ({ placeholder, commentOnly } = {}) => [
  StarterKit.configure({ heading: { levels: [1, 2, 3] } }),
  Underline, TextStyle, Color, FontSize,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  TaskList, TaskItem.configure({ nested: true }),
  Link.configure({ openOnClick: !!commentOnly, autolink: true }),
  Table.configure({ resizable: true }), TableRow, TableHeader, TableCell,
  Image.configure({ inline: false }),
  Placeholder.configure({ placeholder: placeholder || "Start writing…" }),
  CommentMark,
  ...(commentOnly ? [CommentOnly] : []),
];
